<template>
  <div>
    <section class="form-title" :style="{backgroundColor: $store.getters.clientStyle.primary}">
      <div class="container form-title-container">
        <div class="columns is-centered">
          <div class="column is-full">
            <h1 class="is-size-3 has-text-weight-bold"><span v-if="this.$store.getters.getInfo.crow === true">Past Performance: </span>{{ surveyTitle }}</h1>
          </div>
        </div>
      </div>
    </section>
    <section class="intro-section has-background-white-ter" :style="{backgroundImage: 'linear-gradient(' + $store.getters.clientStyle.primary + ', white 80%)'}">
      <div class="container intro" v-if="this.$store.getters.getStatus != 'send-success'">
        <div class="columns">
            <div class="column is-two-fifths intro-stats">
              <div class="stat">
                <p class="stat-title">Project</p>
                <h2 class="is-size-5 has-text-weight-bold">{{ this.$store.getters.getProject }}</h2>
              </div>
              <div class="stat" v-if="this.$store.getters.getInfo.crow === true">
                <p class="stat-title">Organisatie</p>
                <h2 class="is-size-5 has-text-weight-bold">{{this.$store.getters.getCrowMeta.contractor.CROW_contractorInfo.ContractorName}}</h2>
              </div>
              <div class="stat" v-if="this.$store.getters.getInfo.crow === true">
                <p class="stat-title">Adres organisatie</p>
                <h2 class="is-size-5 has-text-weight-bold">
                  {{this.$store.getters.getCrowMeta.contractor.CROW_contractorInfo.Address}},
                  {{this.$store.getters.getCrowMeta.contractor.CROW_contractorInfo.City}}
                </h2>
              </div>
            </div>

          <div class="column">
            <div class="column intro-text has-text-grey-darker">
              <p>{{this.$store.getters.getSurveySettings.instructiontext}}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
    export default {
      data() {
        return {
          crow: this.$store.getters.getCrow
        }
      },
      computed: {
        surveyTitle () {
          let title = this.$store.getters.getSurveySettings.title;
          let fallback = this.$store.getters.getInfo.formName;
  
          return (title != '' && title != null) ? title : fallback
        }
      }
    }
</script>

<style scoped>

.form-title {
  /* border-top-left-radius: 10px;
  border-top-right-radius: 10px; */
  padding-top: 38px;
  padding-bottom: 38px;
  /* background-color: #feb900; */
  /* background-color: #e63126; */
  text-align: center;
  color: white;
  font-size: 16px;
}

.form-title-container {
  padding-left: 20px;
  padding-right: 20px;
}

.intro-section {
  padding-left: 20px;
  padding-right: 20px;
}

.intro {
  padding-top: 60px;
  padding-bottom: 60px;
  padding-left: 40px;
  padding-right: 40px;
  max-width: 980px;

  background-color: white;
  border-radius: 10px;
  box-shadow: 0 1px 30px rgba(0,0,0,0.08);
}

.intro-text {
  padding-left: 18px;
  white-space: pre-wrap;
  /* text-align: left; */
  /* font-size: 14px;
  font-weight: 500; */
}

.intro-stats {
  padding-top: 10px;
  padding-right: 18px;
  text-align: right;
}

.stat {
  margin-top: 10px;
}

.stat-title {
  margin-bottom: -3px;
}

/* .sub-title {
  padding-top: 10px;
  padding-bottom: 40px;
  background-color: #feb900;
  text-align: center;
  color: white;
  font-size: 14px;
  font-weight: 500;
} */
</style>



// WEBPACK FOOTER //
// src/components/elements/intro/Intro.vue